import { ContentState, EditorState, convertToRaw } from 'draft-js';
import convertFromHTML from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import DOMPurify from 'dompurify';

const checkIfAllPtagsAreEmpty = (content: string) => {
  // Extract all matches of <p> tags from the string
  const matches = content.match(/<p>(.*?)<\/p>/gi);

  // Check if all <p> tags contain only &nbsp; as their content
  return matches?.every(match => {
    // Remove <p> tags and any whitespace from the match
    const content = match.replace(/<\/?p>/g, '').trim();
    // Check if the content consists of only &nbsp; characters
    return /^(&nbsp;|\s)*$/.test(content);
  });
};

const checkIfOnlyBrTags = (content: string) => content.replace(/<br\s*\/?>/g, '').trim().length === 0;

const replaceEmptyPTagsWithBr = (content: string): string => content.replace(/<p>\s*<\/p>/g, '<br>');

const emptyContent = (content: string) => checkIfAllPtagsAreEmpty(content) || checkIfOnlyBrTags(content);

const sanitize = (content: string) => DOMPurify.sanitize(replaceEmptyPTagsWithBr(content.trim()));

export const asHTML = (editorState: EditorState) => {
  const contentState = editorState.getCurrentContent();
  const rawContentState = convertToRaw(contentState);
  const sanitizedContent = sanitize(draftToHtml(rawContentState));
  return emptyContent(sanitizedContent) ? '' : sanitizedContent;
};

export const createEditorStateFromHTML = (html?: string): EditorState => {
  if (!html) return EditorState.createEmpty();

  const blocksFromHtml = convertFromHTML(html);
  const initialContentState: ContentState = ContentState.createFromBlockArray(
    blocksFromHtml.contentBlocks,
    blocksFromHtml.entityMap,
  );
  return EditorState.createWithContent(initialContentState);
};

export const convertInitialValueToSanitizedHTML = (initialValue: string): string => {
  const editorState = createEditorStateFromHTML(initialValue);
  return asHTML(editorState);
};
